/**
 * Modal.js
 * Created by calhosh on 6/5/2020.
 */
import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import MotifModal from '@ey/canvascoreservices/Modal';
import ModalError from '../Errors/ModalError';
import {setIsModalOpen, setModalLevel} from '../../../actions/setismodalopen';
import {setFormV2ToasterVisibility} from '../../../actions/toastactions';
import {clearErrors} from '../../../actions/erroractions';

export default function Modal(props) {
	const {
		className = 'defaultModal',
		show,
		onHide,
		onOkClick,
		onSaveAndCreateNew,
		footerLabel = '',
		title,
		children,
		isOkButtonDisabled,
		isCancelButtonDisabled,
		showButtons,
		hideConfirmButton,
		hideCancelButton,
		showSaveAndCreateNewButton,
		confirmBtnTitle,
		closeBtnTitle,
		closeTitle,
		modalsize,
		modalbodystyle,
		modalContainerClass,
		modalonmodal,
		disableClose,
		okTitle,
		footerInfo,
		showCloseButton = true,
		isSaveAndCreateNewButtonDisabled,
		saveAndCreateNewBtnTitle,
		showToolTipButton = false,
		tooltipLabel,
		takeover,
		showFooter,
		customFooter,
		focusTrapPaused,
		labels,
		clearErrorOnClose = true,
		hideCloseButton = false,
		dynamicHeight = false,
		headerChildren
	} = props;

	const dispatch = useDispatch();
	const isModalMounted = useRef(false);
	const isAresView = useSelector((store) => store.isAresView);
	const modalLevel = useSelector((store) => store.modalLevel);
	const modalVal = useRef(modalLevel);

	const resetModalLevel = () => {
		modalVal.current = modalVal.current > 0 ? modalVal.current - 1 : 0;
		dispatch(setModalLevel(modalVal.current));
		modalVal.current === 0 && dispatch(setIsModalOpen(false));
		clearErrorOnClose && dispatch(setFormV2ToasterVisibility(false));
		clearErrorOnClose && dispatch(clearErrors());
		isModalMounted.current = false;
	};

	const handleOnClose = () => {
		onHide && onHide();
	};

	const handleOnOkClick = () => {
		onOkClick && onOkClick();
	};

	useEffect(() => {
		if (show) {
			dispatch(setFormV2ToasterVisibility(false));
			dispatch(clearErrors());
			isModalMounted.current = true;
			modalVal.current = modalVal.current + 1;
			dispatch(setIsModalOpen(true));
			dispatch(setModalLevel(modalVal.current));
		}
		return () => {
			isModalMounted.current && resetModalLevel();
		};
	}, [show]);

	return (
		<MotifModal
			show={show}
			onOkClick={handleOnOkClick}
			onSaveAndCreateClick={onSaveAndCreateNew}
			footerLabel={footerLabel}
			title={title}
			isOkDisabled={isOkButtonDisabled}
			isCancelDisabled={isCancelButtonDisabled}
			showButtons={showButtons}
			hideConfirmButton={hideConfirmButton}
			hideCancelButton={hideCancelButton}
			hideMiddleButton={!showSaveAndCreateNewButton}
			middleButtonTitle={saveAndCreateNewBtnTitle}
			onMiddleButtonClick={onSaveAndCreateNew}
			confirmBtnTitle={confirmBtnTitle}
			closeBtnTitle={closeBtnTitle}
			closeTitle={closeTitle}
			modalsize={modalsize}
			focusTrapPaused={focusTrapPaused}
			modalbodystyle={modalbodystyle}
			modalContainerClass={modalContainerClass}
			disableClose={disableClose}
			okButtonTooltipOverride={okTitle}
			footerInfo={footerInfo}
			showCloseButton={showCloseButton}
			isMiddleButtonDisabled={isSaveAndCreateNewButtonDisabled}
			saveAndCreateNewBtnTitle={saveAndCreateNewBtnTitle}
			showToolTipButton={showToolTipButton}
			tooltipLabel={tooltipLabel}
			footerError
			onClose={handleOnClose}
			className={`${className} ${modalsize} ${modalContainerClass} ${isAresView ? 'AresModal' : 'KronosModal'}`}
			modalonmodal={modalonmodal}
			takeover={takeover}
			showFooter={showFooter}
			customFooter={customFooter}
			labels={labels}
			hideCloseButton={hideCloseButton}
			dynamicHeight={dynamicHeight}
			headerChildren={headerChildren}
		>
			<ModalError modalLevel={modalVal.current} />
			{children}
		</MotifModal>
	);
}

Modal.propTypes = {
	className: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.bool]),
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	modalsize: PropTypes.string,
	confirmBtnTitle: PropTypes.string,
	closeBtnTitle: PropTypes.string,
	closeTitle: PropTypes.string,
	modalbodystyle: PropTypes.string,
	modalContainerClass: PropTypes.string,
	showButtons: PropTypes.bool,
	hideConfirmButton: PropTypes.bool,
	hideCancelButton: PropTypes.bool,
	isOkButtonDisabled: PropTypes.bool,
	isCancelButtonDisabled: PropTypes.bool,
	onHide: PropTypes.func,
	onOkClick: PropTypes.func,
	disabled: PropTypes.bool,
	show: PropTypes.bool
};
